import { useNavigate } from "react-router-dom";
import { chatItems } from "../../utils/data";
import useAgentData from "../../utils/hooks/useAgentData";

const ActiveChats = () => {
  const navigate = useNavigate();
  const { activeChats, loading } = useAgentData();

  if (loading) return null;

  const cardData = chatItems(activeChats);

  return (
    <div className="md:w-1/2 w-full flex-col bg-white shadow-[4px_4px_47.1px_0px_#00000040] rounded-[12px] flex items-start py-4 gap-4">
      <span className="w-full border-b pb-6 pl-3 border-[#0000002B] h-[15px] text-[13px] font-semibold font-inter leading-[100%] text-black">
        Active Chats
      </span>

      {cardData.map((item, index) => (
        <div
          key={index}
          className="flex flex-row items-center w-full gap-1 px-3 cursor-pointer"
          onClick={() => navigate("/chat")}
        >
          <div className="relative">
            <img
              src={item.image}
              alt={item.name}
              className="w-[45px] h-[45px] rounded-full object-contain"
            />
            <div
              className={`w-[10px] h-[10px] border-2 border-white rounded-full absolute bottom-0 right-0 ${
                item.status === "available" ? "bg-[#4DFF00]" : "bg-[#E4E000]"
              }`}
            />
          </div>

          <div className="flex flex-col w-full">
            <div className="flex items-center justify-between w-full">
              <span className="text-[12px] font-semibold font-inter leading-[100%] text-black">
                {item.name}
              </span>
              <span className="text-[11px] font-medium font-inter leading-[100%] text-[#00000073] px-2 py-0.5 rounded">
                {item.time}
              </span>
            </div>
            <div className="text-[11px] py-1 font-inter text-[#00000073] text-opacity-80">
              {item.message}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ActiveChats;
